/*
 */

import TeamCalendar                     from './TeamCalendar'
import TeamEditOverlay                  from './TeamEditOverlay'


/**
 * The main REACT component for managing a team. This manages an overlay for 
 * adding and removing team members as well as the team calendar. Communication
 * goes via the main dispatch/state to/from the left menu area.
 * @param {function}    api             For communication with the IPRS API
 * @param {function}    eventDispatch   To communicate with the rest of the 
 *                                      application
 * @param {type}        state           The current application state
 * @returns {JSX}                       Renderable content
 */
const TeamEdit = ({api, eventDispatch, state}) => {
    
    const {editTeam}        =   state
    
    return (
        <>
            {editTeam? <TeamEditOverlay api={api} eventDispatch={eventDispatch} state={state} />: ''}
            <TeamCalendar api={api} eventDispatch={eventDispatch} state={state} />
        </>
    )
}

export default TeamEdit


